import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../components/AuthContext";
import { toast } from "react-toastify";
import registrationVideo from "../assets/registation-video.mp4";
import "../styles/GameRegistration.css";
import API from "../api/axios";

export default function GameRegisterPage() {

  const [arenaStats, setArenaStats] = useState({
  totalRegistered: 0,
  totalSlots: 20000,
  remainingSlots: 20000,
});

const [registered, setRegistered] = useState(0);


  const { register } = useAuth();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: ""
  });

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({
  name: "",
  email: "",
  phone: "",
  password: "",
  confirmPassword: "",
  general: ""
});

useEffect(() => {
  const loadArenaStats = async () => {
    try {
      const { data } = await API.get("/games/stats");

      setArenaStats({
        totalRegistered: data.totalRegistered,
        totalSlots: data.totalSlots,
        remainingSlots: data.remainingSlots,
      });
    } catch (err) {
      console.error("Arena Stats Error", err);
    }
  };

  loadArenaStats();
}, []);

useEffect(() => {
  if (arenaStats.totalRegistered <= 0) return;

  let current = 0;

  const timer = setInterval(() => {
    current += Math.ceil(
      (arenaStats.totalRegistered - current) / 18
    );

    if (current >= arenaStats.totalRegistered) {
      current = arenaStats.totalRegistered;
      clearInterval(timer);
    }

    setRegistered(current);
  }, 40);

  return () => clearInterval(timer);
}, [arenaStats.totalRegistered]);

// useEffect(() => {

//     let current = 0;

//     const timer = setInterval(() => {

//       current += Math.ceil((TARGET - current) / 18);

//       if (current >= TARGET) {

//         current = TARGET;

//         clearInterval(timer);

//       }

//       setCount(current);

//     }, 40);


//     return () => clearInterval(timer);

//   }, []);


  const handleChange = (e) => {

    let { name, value } = e.target;

    if (name === "phone") {

      value = value.replace(/\D/g, "");

    }

    setForm((prev) => ({
      ...prev,
      [name]: value
    }));

    setErrors(prev => ({
    ...prev,
    [name]: "",
    general: ""
}));

  };

  const handleSubmit = async (e) => {

    e.preventDefault();

setErrors({
  name: "",
  email: "",
  phone: "",
  password: "",
  confirmPassword: "",
  general: ""
});

const {
  name,
  email,
  phone,
  password,
  confirmPassword
} = form;

const newErrors = {};

if (!name.trim()) {
  newErrors.name = "Please enter your full name.";
}

if (!/\S+@\S+\.\S+/.test(email)) {
  newErrors.email = "Please enter a valid email address.";
}

if (!/^[6-9]\d{9}$/.test(phone)) {
  newErrors.phone = "Please enter a valid 10-digit mobile number.";
}

if (password.length < 6) {
  newErrors.password = "Password must be at least 6 characters.";
}

if (password !== confirmPassword) {
  newErrors.confirmPassword = "Passwords do not match.";
}

if (Object.keys(newErrors).length > 0) {
  setErrors(newErrors);
  return;
}
    setLoading(true);

    try {

      const res = await register(
        name,
        email,
        phone,
        password
      );

     if (res.success) {

    toast.success("OTP sent successfully.");

    navigate("/verify-otp", {
        state: { source: "game" }
    });

} else {

    const msg = (res.message || "").toLowerCase();

    if (msg.includes("email")) {

        setErrors(prev => ({
            ...prev,
            email: "This email is already registered."
        }));

    } else if (
        msg.includes("phone") ||
        msg.includes("mobile")
    ) {

        setErrors(prev => ({
            ...prev,
            phone: "This mobile number is already registered."
        }));

    } else {

        setErrors(prev => ({
            ...prev,
            general: res.message || "Registration failed."
        }));

    }

}

} catch (err) {

  setErrors(prev => ({
    ...prev,
    general: "Something went wrong. Please try again."
  }));

} finally {

  setLoading(false);

}
};

  return (

    <section className="registration-section">

      {/* <img
        src="https://i.ibb.co/TM1bCtWk/game-theme-registration.png"
        alt="SAC Rider Arena"
        className="registration-bg"
      /> */}

      <div className="registration-overlay"></div>

      <div className="fog"></div>

      <span className="particle p1"></span>
      <span className="particle p2"></span>
      <span className="particle p3"></span>
      <span className="particle p4"></span>
      <span className="particle p5"></span>

      <div className="registration-container">

        {/* LEFT */}

        <div className="registration-left">


  <h1 className="hero-title-game">
  Play 3D Game
  <br />
  <span className="sac-arena">SAC Arena</span>
  <br />
   <span className="powered-by">Powered by SAC MTB</span>
  </h1>

  <h2 className="hero-subtitle">
    Get Your Participation ID Today 
    <br/>
    To Reserve Your Seat before launching the Game
    <br/>
    Get a Chance to Win a <span className="highlight">SAC MTB Bicycle OR Any one of SAC MTB Product </span> Every Month
  </h2>

  <div className="trust-row">

    <span>🎟️ Participation ID</span>

    <span>🚀 Early Access</span>

    <span>🎁 FREE Bicycle for the #1 Winner</span>

  </div>
  {errors.general && (
<div className="general-error">
    {errors.general}
</div>
)}

          <form
            className="registration-form"
            onSubmit={handleSubmit}
          >

            <input
    type="text"
    name="name"
    className={errors.name ? "error" : ""}
    placeholder="Full Name"
    value={form.name}
    onChange={handleChange}
/>

{errors.name && (
<div className="field-error">
    {errors.name}
</div>
)}

 <input
  type="email"
  name="email"
  className={errors.email ? "error" : ""}
  placeholder="Email Address"
  value={form.email}
  onChange={handleChange}
/>

{errors.email && (
  <div className="field-error">
    {errors.email}
  </div>
)}

<input
  type="tel"
  name="phone"
  className={errors.phone ? "error" : ""}
  placeholder="Phone Number"
  maxLength={10}
  value={form.phone}
  onChange={handleChange}
/>

{errors.phone && (
  <div className="field-error">
    {errors.phone}
  </div>
)}

  <input
  type="password"
  name="password"
  className={errors.password ? "error" : ""}
  placeholder="Password"
  value={form.password}
  onChange={handleChange}
/>

{errors.password && (
  <div className="field-error">
    {errors.password}
  </div>
)}

 <input
  type="password"
  name="confirmPassword"
  className={errors.confirmPassword ? "error" : ""}
  placeholder="Confirm Password"
  value={form.confirmPassword}
  onChange={handleChange}
/>

{errors.confirmPassword && (
  <div className="field-error">
    {errors.confirmPassword}
  </div>
)}

            <button
              type="submit"
              disabled={loading}
            >
              {loading
                ? "Creating Account..."
                : "🎟️ Get My Participation ID"}
            </button>
                      </form>

<div className="hero-note">
  🚴 Your Journey Starts Here!
</div>

<div className="register-info">

  <p>🎟️ Secure Your Participation ID Today</p>

  <p>🚀 Be Among the First to Play at Launch</p>

</div>
          <p className="auth-switch">

            Already have an account?

            <Link to="/login"> Login</Link>

          </p>

        </div>

        {/* RIGHT */}

<div className="registration-right">

  <div className="registration-live-card">

    <div className="registration-live-header">
      <span>🚴 LIVE REGISTRATION</span>
      <span className="live-indicator">● LIVE</span>
    </div>

    <div className="registration-live-stats">

      <div className="live-stat">
        <strong>
          {registered.toLocaleString()}
        </strong>
        <span>Registered Riders</span>
      </div>

      <div className="live-stat">
        <strong>
          {arenaStats.totalSlots.toLocaleString()}
        </strong>
        <span>Total Slots</span>
      </div>

      <div className="live-stat">
        <strong>
          {arenaStats.remainingSlots.toLocaleString()}
        </strong>
        <span>Remaining Slots</span>
      </div>

    </div>

    <div className="registration-progress">
      <div
        className="registration-progress-fill"
        style={{
          width: `${
            arenaStats.totalSlots > 0
              ? (registered / arenaStats.totalSlots) * 100
              : 0
          }%`,
        }}
      />
    </div>

    <p className="registration-live-message">
      🔥 Join SAC Arena before the available slots fill up!
    </p>

  </div>

  {/* VIDEO MUST COME HERE */}
  <video
    className="registration-video"
    autoPlay
    muted
    loop
    playsInline
    preload="auto"
  >
    <source
      src={registrationVideo}
      type="video/mp4"
    />
  </video>

</div>
</div>
    </section>

  );

}